import React from 'react';

const rooms = [
  {
    name: 'Twin Room',
    price: '$60 / night',
    image: '/images/twin_room.jpg', // Replace with actual file name
    description: '301 ft² – 1 full bed. Private kitchen, bathroom, balcony with sea, garden, and city views. Includes patio, dishwasher, flat-screen TV, coffee machine, and more.',
  },
  {
    name: 'Family Room (King Bed)',
    price: '$120 / night',
    image: '/images/family_room_king_bed.jpg',
    description: '689 ft² – 1 king bed. Private pool, kitchen, and terrace with views. Air-conditioning, patio, TV, and full amenities. Breakfast available.',
  },
  {
    name: 'Family Room (King Bed)',
    price: '$80 / night',
    image: '/images/family_room.jpg',
    description: '258 ft² – 1 king bed. Private pool, hot tub, and balcony. Sea, mountain, and garden views. Kitchen, BBQ, coffee machine, and outdoor dining.',
  },
  {
    name: 'Double Room with Private Bathroom',
    price: '$80-160 / night',
    image: '/images/double_room.jpg',
    description: '517 ft² – 2 queen beds. Private bathroom, kitchen, and terrace. City and pool views. Ideal for families. Breakfast included in some options.',
  },
];

function Rooms() {
  return (
    <div className="p-10 max-w-6xl mx-auto">
      <h1 className="text-3xl font-bold mb-6 text-center text-blue-900">Rooms at Cidade Serena</h1>
      <div className="grid md:grid-cols-2 gap-6">
        {rooms.map((room, index) => (
          <div
            key={index}
            className="border rounded-lg shadow hover:shadow-lg transition duration-300 bg-white"
          >
            <img
              src={room.image}
              alt={room.name}
              className="w-full h-52 object-cover rounded-t"
            />
            <div className="p-4 text-center">
              <h2 className="text-xl font-semibold text-blue-800">{room.name}</h2>
              <p className="text-sm text-gray-600 mt-2">{room.description}</p>
              <p className="text-blue-900 font-bold mt-3">{room.price}</p>
              <a
                href="https://www.booking.com/Share-T8MFzr"
                target="_blank"
                rel="noopener noreferrer"
                className="mt-4 inline-block bg-blue-700 text-white px-4 py-2 rounded hover:bg-blue-800"
              >
                Book on Booking.com
              </a>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Rooms;
